import { Injectable } from '@angular/core';
import { GenericResponse } from '../business-entities/generic-response';
import { EditPackageDetails, PackageModel } from '../business-entities/package-model';
import { PackageDataService } from '../data-services/package-data.service';
import { PackageListRequestModel } from '../business-entities/package-list-request-model';
import { PackageBOMResponseModel } from '../business-entities/package-list-model';
import { ServiceViewModel } from '../business-entities/service-view-model';

@Injectable({
    providedIn: 'root'
})

export class PackageService {
    packageDetail: EditPackageDetails;
    packageList: PackageModel[];
    packageId: number = 0;
    UnitPriceDealer: number;
    packageVersionBOM: PackageBOMResponseModel[] = [];
    dealerServicesList: ServiceViewModel[] = [];
    dealerId: string = "";
    packageMakeCode:string = "";
    packageVersionName:string = "";
    sourceId:number = 0;
    appointmentType:string = "";
    isFromAdditionalWork:boolean = false;
    sourceTypeId: number = 1;
    // serviceList:ServiceViewModel;

    packageListRequest: PackageListRequestModel =
        {
            startRecordNumber: 0,
            pageSize: 25,
            sortColumn: '',
            sortDirection: '',
            searchTerm: '',
            statusId: 0,
            cultureCode: '',
            syncId: 0,
            sourceOfCreation: '',
            sourceId:0,
            dealerId:''
        }
    packageNumber: string;
    constructor(private service: PackageDataService) {
    }

    async getPackage(id: string, code: any) {
        await this.service
            .getPackage(id, code)
            .then(
                (res: GenericResponse<Array<PackageModel>>) => {
                    this.packageList = res.responseObject;
                }
            );

        return this.packageList;
    }

    AddPackage(model: any): Promise<any> {
        return this.service.AddPackage(model);
    }
    EditPackage(model: any): Promise<any> {
        return this.service.EditPackage(model);
    }

    deletePackage(Id: string) {
        return this.service.deletePackage(Id);
    }
    getPackageById(packageNumber: string) {
        return this.service.getPackageById(packageNumber);
    }

    getPackageList(packageListRequestModel: PackageListRequestModel) {
        return this.service.getPackageList(packageListRequestModel);
    }

    GetPackageVersionByPackageNo(packageId: number, langCode: string) {
        return this.service.GetPackageVersionByPackageNo(packageId, langCode);
    }

    GetPackageBOMByPackageNo(packageId: number, packageVersionId: number, dealerId: string,allowDealerBrandLaborRate :boolean) {
        return this.service.GetPackageBOMByPackageNo(packageId, packageVersionId, dealerId,allowDealerBrandLaborRate);
    }

    GetBillOfMaterialType() {
        return this.service.GetBillOfMaterialType();
    }

    async GetPackageDetails(packageId: number) {
        return this.service.GetPackageDetails(packageId);
    }

    AddUpdatePackage(packageRequestModel: any): Promise<any> {
        return this.service.AddUpdatePackage(packageRequestModel);
    }
    async getSearchPackage(model: any): Promise<any> {
        return this.service.getSearchPackage(model)
    }

    DeletePackageVersion(packageId: number, packageVersionId: number) {
        return this.service.DeletePackageVersion(packageId, packageVersionId);
    }

    DeletePackageByNumber(packageId: number) {
        return this.service.DeletePackageByNumber(packageId);
    }
    async ResyncPackage(packageId: number): Promise<GenericResponse<any>> {
        return this.service.ResyncPackage(packageId);
    }

    async getAfxPackageDropdown(model: any): Promise<any> {
        return this.service.getAfxPackageDropdown(model)
    }

    async GetPackageBOMByDealerServiceId(dealerServiceId: number) {
        return this.service.GetPackageBOMByDealerServiceId(dealerServiceId);
    }
    
    async DuplicatePackage(packageRequestModel: any): Promise<any> {
        return this.service.DuplicatePackage(packageRequestModel);
    }
}
